import React from 'react';

import { Box, CircularProgress } from '@material-ui/core';

import { LoadingIcon } from '../LoadingIcon';

export function LoadingPage() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
      }}
    >
      <LoadingIcon />
    </Box>
  );
}
